import {useCallback, useEffect, useState} from "react";
import {getHomeDashboardData} from "./HomeService";
import {normalizeHomeDashboard} from "./homeUtils";

const createInitialState = () => ({
    metrics: {
        empresasAtivas: 0,
        sistemasAtivos: 0,
        assinaturas: 0,
        receitaMensal: 0,
    },
    recentActivities: [],
    failedSections: [],
});

export const useHomeDashboard = () => {
    const [dashboard, setDashboard] = useState(createInitialState);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const loadDashboard = useCallback(async () => {
        setLoading(true);
        setError('');

        try {
            const responses = await getHomeDashboardData();
            const normalized = normalizeHomeDashboard(responses);
            setDashboard(normalized);

            if (normalized.failedSections.length) {
                setError('Algumas informações do dashboard não puderam ser carregadas.');
            }
        } catch {
            setDashboard(createInitialState());
            setError('Não foi possível carregar o dashboard.');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        loadDashboard();
    }, [loadDashboard]);

    return {
        ...dashboard,
        loading,
        error,
        reload: loadDashboard,
    };
};
